import { DraftClinicalAndDocDto } from '../../interfaces/DraftClinicalAndDocDto';
import { PriorAuthorizationBaseDto } from '../../interfaces/PriorAuthorizationBaseDto';
import * as api from '../api.service';
// this will return the data to seed the precertificationIntake form
const get = async (data: any) => {
  const
    response = api.post<PriorAuthorizationBaseDto>(`${process.env.REACT_APP_API_URL}/prior-authorization/create`, data);
  return response;
};

const getDraftClinicalAndDocDto = async () => {
  const response = api.fetchData<DraftClinicalAndDocDto>(`${process.env.REACT_APP_API_URL}/prior-authorization/get`);
  return response;
};

const FormDataService = {
  get,
  getDraftClinicalAndDocDto,
};

export default FormDataService;
